module.exports = __webpack_public_path__ + "static/media/img17.9c34cb0e.jpeg";